import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const LoginWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f4f7f9 0%, #e9ecef 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 600px;
    height: 600px;
    background: var(--waya-red-glass);
    border-radius: 50%;
    top: -200px;
    right: -200px;
    filter: blur(100px);
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    background: rgba(31, 38, 135, 0.05);
    border-radius: 50%;
    bottom: -100px;
    left: -100px;
    filter: blur(80px);
    z-index: 0;
  }

  .auth-container {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1100px;
    display: flex;
    gap: 40px;
    padding: 20px;
    animation: ${fadeIn} 0.8s ease-out;
  }

  .auth-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: var(--text-main);
    
    @media (max-width: 992px) {
      display: none;
    }

    h1 {
      font-size: 4rem;
      font-weight: 700;
      line-height: 1.1;
      margin-bottom: 24px;
      background: linear-gradient(to bottom right, var(--text-main), var(--waya-red));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      font-size: 1.25rem;
      color: var(--text-muted);
      max-width: 500px;
      line-height: 1.6;
    }
  }

  .auth-form-section {
    width: 450px;
    @media (max-width: 992px) {
      width: 100%;
      max-width: 450px;
      margin: 0 auto;
    }
  }

  .logo-container {
    margin-bottom: 40px;
    img {
      height: 40px;
    }
  }
`;

export const ForgotPasswordWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f7f9;
`;

const style = {
  // Keeping this for legacy compatibility if needed, but moving to styled components
  login: {
    formContainer: {
      width: '100%',
    }
  }
};

export default style;
